import React, { FC, ReactElement } from "react";
import classNames from "classnames/bind";
import scss from "./Pagination.module.scss";
const cn = classNames.bind(scss);

import { Arrow } from "components/Svg/Arrow";

type Pagination = {
  currentPage: number;
  totalPages: number;
  onChangePage: (page: number) => void;
};

const Pagination: FC<Pagination> = ({ currentPage, totalPages, onChangePage }): ReactElement => {
  if (totalPages <= 1) return <></>;

  const changePageHandler = (event: React.MouseEvent, page: number) => {
    event.preventDefault();
    onChangePage(page);
  };

  const renderPageButtons = () => {
    const pageButtons = [];

    if (totalPages <= 5) {
      for (let page = 1; page <= totalPages; page++) {
        const isActive = page === currentPage;
        pageButtons.push(
          <a key={page} className={cn("pagination__page", { isActive: isActive })} onClick={() => onChangePage(page)}>
            {page}
          </a>
        );
      }
    } else {
      const lastPage = Math.min(totalPages, currentPage + 2 + Math.max(0, 4 - currentPage));
      const firstPage = Math.max(1, currentPage - 2 - Math.abs(Math.min(0, totalPages - (3 + currentPage))));

      for (let page = firstPage; page <= lastPage; page++) {
        const isActive = page === currentPage;
        pageButtons.push(
          <a
            key={page}
            className={cn("pagination__page", { isActive: isActive })}
            onClick={(event) => changePageHandler(event, page)}
          >
            {page}
          </a>
        );
      }

      if (firstPage !== 1) {
        pageButtons.unshift(
          <a key={1} className={cn("pagination__page")} onClick={(event) => changePageHandler(event, 1)}>
            1
          </a>,
          <span key="dots1" className={cn("dots")}>
            ...
          </span>
        );
      }

      if (currentPage < totalPages - 2) {
        pageButtons.push(
          <span key="dots2" className={cn("dots")}>
            ...
          </span>,
          <a
            key={totalPages}
            className={cn("pagination__page")}
            onClick={(event) => changePageHandler(event, totalPages)}
          >
            {totalPages}
          </a>
        );
      }
    }

    return pageButtons;
  };

  return (
    <>
      {totalPages && (
        <div className={cn("pagination-box")}>
          <div className={cn("pagination")}>
            <div
              onClick={(event) => currentPage !== 1 && changePageHandler(event, currentPage - 1)}
              className={cn("pagination__navbtn", "left", { ["disabled"]: currentPage === 1 })}
            >
              <Arrow />
            </div>
            {renderPageButtons()}
            <div
              onClick={(event) => currentPage !== totalPages && changePageHandler(event, currentPage + 1)}
              className={cn("pagination__navbtn", { ["disabled"]: currentPage === totalPages })}
            >
              <Arrow />
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export { Pagination };
